import { Map } from 'immutable';
import { setOpenFiltersType } from './ResultsFiltersConstants';

export const initialState = Map({
  open: false,
});

// eslint-disable-next-line default-param-last
export default function resultsFiltersReducer(state = initialState, action) {
  switch (action.type) {
    case setOpenFiltersType: {
      const { isOpen } = action.payload;

      return state.set('open', isOpen);
    }

    default: {
      return state;
    }
  }
}
